<template>
        <div class="contentRes">
            <div class="contentList">
                <div class="contentStep1Box">
                    <div class="step1Title">病情评估<span style="color:#EC0101">*</span><span style='font-size: 14px;color: #666666;margin-left:20px;font-weight: 400;' >简单描述，以便为您提供更优质的服务</span></div>
                    <div class="step2Title" style="margin-bottom:40px;margin-top:20px" v-for="(item,index) in queslistDocData" :key="index">
                        <div>
                            <span style="margin-right:5px">0{{index + 1}}/07</span> {{item.queName}}<span style="color:#EC0101;font-size: 14px;margin-left:10px" v-if="item.queDes">（{{item.queDes}}）</span>
                        </div>
                        <div v-if="index == 0">
                            <div class="DocTopFlexS" style="margin-top:20px">
                                <div class="DocTopFlexC" style="width:48%">
                                    <span>身高<span style="color:#EC0101;margin-right:10px">*</span></span>
                                    <el-input
                                        style="width:80%"
                                        class="diseaseBox"
                                        :rows="3"
                                        placeholder="请输入患者身高cm"
                                        v-model="item.patientHeight">
                                        <template slot="append">cm</template>
                                    </el-input>
                                </div>
                                <div class="DocTopFlexC" style="width:48%"> 
                                    <span>体重<span style="color:#EC0101;margin-right:10px">*</span></span>
                                    <el-input
                                        style="width:80%"
                                        class="diseaseBox"
                                        :rows="3"
                                        placeholder="请输入患者体重kg"
                                        v-model="item.patientWeight">
                                        <template slot="append">kg</template>
                                    </el-input>
                                </div>
                            </div>
                            <div class="DocTopFlexC" style="margin-top:15px">
                                <span style="margin-right:10px">测量时间</span>
                                <el-date-picker
                                    style="width:87%"
                                    class="diseaseBox"
                                    v-model="item.patienTtestTime"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="请选择患者测量时间">
                                </el-date-picker>
                            </div>
                        </div>
                        <div v-if="item.queDesOption" class="DocTopFlexC" style="margin-top:20px">
                            <div class="" v-for="(item1,index1) in item.queDesOption" :key="item1.name"
                                @click="goChooseQues(item1,index1,index)">
                                <div :class="item1.name == item.quesAnsName ? 'BoxCheckG' : 'BoxG'  ">
                                    {{item1.name}}
                                </div>
                            </div>
                        </div>
                        <div v-if="item.quesAnsName == '就诊过' && index == 2" >
                            <div class="" style="margin-top:15px"> 
                                <span>就诊医院</span>
                                <el-input
                                    style="margin-top:5px"
                                    class="diseaseBox"
                                    placeholder="请填写就诊过的医院名称"
                                    v-model="item.patientHisHos">
                                </el-input>
                            </div>
                            <div class="" style="margin-top:15px"> 
                                <span>就诊科室</span>
                                <el-input
                                    style="margin-top:5px"
                                    class="diseaseBox"
                                    placeholder="请输入就诊科室名称"
                                    v-model="item.patientHisDep">
                                </el-input>
                            </div>
                        </div>
                        <div v-if="item.quesAnsName == '有' && index == 3" >
                            <div class="" style="margin-top:15px"> 
                                <span>请填写患者当前使用的药物</span>
                                <el-input
                                    type="textarea"
                                    style="margin-top:5px"
                                    :rows="3"
                                    class="diseaseBox"
                                    placeholder="请详细描述服用药物的名称、服用方法、剂量等信息…"
                                    v-model="item.patientHisDrug">
                                </el-input>
                            </div>
                        </div>
                        <div v-if="item.quesAnsName == '有' && index == 4" >
                            <div class="" style="margin-top:15px" v-for="(item2,index2) in item.queDesOptionYes" :key="index2"> 
                                <el-checkbox v-model="item2.checked">{{item2.name}}</el-checkbox>
                                <el-input
                                    type="textarea"
                                    style="margin-top:5px"
                                    :rows="3"
                                    class="diseaseBox"
                                    :placeholder="item2.desPlaceholder"
                                    v-model="item2.des">
                                </el-input>
                            </div>
                        </div>
                        <div v-if="item.quesAnsName == '有' && index == 5" >
                            <div class="" style="margin-top:15px"> 
                                <span>慢性病</span>
                                <el-input
                                    type="textarea"
                                    style="margin-top:5px"
                                    :rows="3"
                                    class="diseaseBox"
                                    placeholder="何时确诊，什么慢性疾病(如糖尿病、高血压等）..."
                                    v-model="item.diseasesDes">
                                </el-input>
                            </div>
                        </div>
                        <div v-if="item.quesAnsName == '有' && index == 6" >
                            <div class="" style="margin-top:15px"> 
                                <span>药物过敏史</span>
                                <el-input
                                    type="textarea"
                                    style="margin-top:5px"
                                    :rows="3"
                                    class="diseaseBox"
                                    placeholder="填写对什么药品过敏"
                                    v-model="item.drugDes">
                                </el-input>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="step2Title" style="margin-bottom:15px;margin-top:25px">上传检查报告/患处照片</div> -->
                    <!-- <el-upload :headers="headers" :action="FileUploadUrl" list-type="picture-card" :limit="5" multiple :on-preview="handleImagePreview" :on-remove="handleImageRemove" :on-success="handleImageUpload" :on-exceed="$imgConfig.exceed" :before-upload="$imgConfig.onBeforeUpload" accept=".png,.jpg,.jpeg,.gif">
                      <i class="el-icon-plus"></i>
                    </el-upload> -->
                    <div class="DocTopFlexC" style="margin-top:50px">
                        <div class="canBtnBox" @click="goCanBtn">
                            上一步
                        </div>
                        
                        <div class="stepBtnBox" @click="goNextStep">
                            下一步:病情评估
                        </div>
                    </div>
                    <div style="margin-top:15px"><el-checkbox v-model="cssagree" style="margin-right:10px"></el-checkbox> 我已经阅读并同意<router-link target="_blank" to="/company/onLineNotice"><span style="color:#E74848">《互联网风险告知书》</span> </router-link>和<router-link target="_blank" to="/company/onInfoAgress"><span style="color:#E74848">《个人信息使用授权协议》</span></router-link></div>
                </div>
            </div>
            <el-dialog :visible.sync="Image.dialogVisible">
                  <img width="100%" :src="Image.dialogImageUrl" alt="" />
            </el-dialog>
        </div>
</template>

<script>
import { consultationMain } from "../../components/consultation/consultation";
export default {
    props: ['mesStep1', 'patientDiagnoseDetail1'],
    data() {
        var consultationMainItem = new consultationMain(this.TokenClient, this.Services.Authorization);
        var consultationDrugItem = new consultationMain(this.TokenClient, this.Services.Drug);
        return {
            consultationDomain: consultationMainItem,
            consultationDrugDomain:consultationDrugItem,
            asstoken:'',
            FileUploadUrl: this.Services.Statics + "/api/upload",
            Image: {
                //单击图片上传控件中的图片时，放大显示
                dialogVisible: false,
                dialogImageUrl: "",
            },
            ImageContent:[],
            cssagree:false,
            queslistDocData: [{
                    queName: '请填写患者的身高和体重',
                    queDes: '身高和体重有助于医生评估整体健康状况！',
                    patientHeight: '',
                    patientWeight: '',
                    patienTtestTime: '',
                },
                {
                    queName: '本次患病多久了?',
                    queDes: '',
                    quesAnsName: '',
                    queDesOption: [{
                            name: '一周以内'
                        },
                        {
                            name: '一月以内'
                        },
                        {
                            name: '半年以内'
                        },
                        {
                            name: '半年以上'
                        },
                    ]
                },
                {
                    queName: '本次疾病去医院就诊过吗?',
                    queDes: '曾经的就诊经历，是给医生的重要参考！',
                    quesAnsName: '',
                    queDesOption: [{
                            name: '就诊过'
                        },
                        {
                            name: '没就诊过'
                        }
                    ],
                    patientHisHos: '',
                    patientHisDep: ''
                },
                {
                    queName: '当前是否有正在使用的药物?',
                    queDes: '患者当前药物服用的实际情况，是医生回复前必须了解的。',
                    quesAnsName: '',
                    queDesOption: [{
                            name: '有'
                        },
                        {
                            name: '没有'
                        }
                    ],
                    patientHisDrug: '',
                    patientHisDrugPhoto: []
                },
                {
                    queName: '是否有过手术、放化疗等重大疾病治疗经历?',
                    queDes: '',
                    quesAnsName: '',
                    queDesOption: [{
                            name: '有'
                        },
                        {
                            name: '没有'
                        }
                    ],
                    queDesOptionYes: [{
                            name: '手术',
                            des: '',
                            checked: false,
                            desPlaceholder: '填写您做手术的时间、医院和所患疾病等信息'
                        },
                        {
                            name: '放化疗',
                            des: '',
                            checked: false,
                            desPlaceholder: '填写您做放化疗的时间、医院和所患疾病等信息'
                        },
                        {
                            name: '重大疾病',
                            des: '',
                            checked: false,
                            desPlaceholder: '(如恶性肿瘤，器官功能衰竭，肢体缺损畸形等)'
                        }
                    ]
                },
                {
                    queName: '是否有慢性病史?',
                    queDes: '',
                    quesAnsName: '',
                    queDesOption: [{
                            name: '有'
                        },
                        {
                            name: '没有'
                        }
                    ],
                    diseasesDes: ''
                },
                {
                    queName: '是否有药物过敏史?',
                    queDes: '若需要开处方，医生将会参考您的药物过敏史。',
                    quesAnsName: '',
                    queDesOption: [{
                            name: '有'
                        },
                        {
                            name: '没有'
                        }
                    ],
                    drugDes: ''
                },
            ],
        }
    },
    computed: {
        headers() {
        return {
            Authorization: "Bearer" + " " + this.asstoken,
        };
        },
    },
    async mounted(){
        this.http = this.Services.ossUpload;
        			if (this.patientDiagnoseDetail1) {
				for (let i = 0; i < this.patientDiagnoseDetail1.patientAnswerRecords.length; i++) {
					this.patientDiagnoseDetail1.patientAnswerRecords[i].userAnswer = JSON.parse(this.patientDiagnoseDetail1
						.patientAnswerRecords[i].userAnswer)
				}
				this.queslistDocData[0].patientHeight = this.patientDiagnoseDetail1.patientAnswerRecords[0].userAnswer[0]
					.otherData[0].patientHeight
				this.queslistDocData[0].patientWeight = this.patientDiagnoseDetail1.patientAnswerRecords[0].userAnswer[0]
					.otherData[0].patientWeight
				this.queslistDocData[0].patienTtestTime = this.patientDiagnoseDetail1.patientAnswerRecords[0].userAnswer[0]
					.otherData[0].patienTtestTime
				this.queslistDocData[1].quesAnsName = this.patientDiagnoseDetail1.patientAnswerRecords[1].userAnswer[0]
					.quesAnsName
				this.queslistDocData[2].quesAnsName = this.patientDiagnoseDetail1.patientAnswerRecords[2].userAnswer[0]
					.quesAnsName
				this.queslistDocData[2].patientHisDep = this.patientDiagnoseDetail1.patientAnswerRecords[2].userAnswer[0]
					.otherData[0].patientHisDep
				this.queslistDocData[2].patientHisHos = this.patientDiagnoseDetail1.patientAnswerRecords[2].userAnswer[0]
					.otherData[0].patientHisHos
				this.queslistDocData[3].quesAnsName = this.patientDiagnoseDetail1.patientAnswerRecords[3].userAnswer[0]
					.quesAnsName
				this.queslistDocData[3].patientHisDrug = this.patientDiagnoseDetail1.patientAnswerRecords[3].userAnswer[0]
					.otherData[0].patientHisDrug
				this.queslistDocData[3].patientHisDrugPhoto = this.patientDiagnoseDetail1.patientAnswerRecords[3]
					.userAnswer[0].otherData[0].patientHisDrugPhoto
				this.queslistDocData[4].quesAnsName = this.patientDiagnoseDetail1.patientAnswerRecords[4].userAnswer[0]
					.quesAnsName
				this.queslistDocData[4].queDesOptionYes = this.patientDiagnoseDetail1.patientAnswerRecords[4].userAnswer[0]
					.otherData
				this.queslistDocData[5].quesAnsName = this.patientDiagnoseDetail1.patientAnswerRecords[5].userAnswer[0]
					.quesAnsName
				this.queslistDocData[5].diseasesDes = this.patientDiagnoseDetail1.patientAnswerRecords[5].userAnswer[0]
					.otherData[0].diseasesDes
				this.queslistDocData[6].quesAnsName = this.patientDiagnoseDetail1.patientAnswerRecords[6].userAnswer[0]
					.quesAnsName
				this.queslistDocData[6].drugDes = this.patientDiagnoseDetail1.patientAnswerRecords[6].userAnswer[0]
					.otherData[0].drugDes
			}
    },
    methods: {
        goChooseQues(item, index1, index) {
            this.queslistDocData[index].quesAnsName = item.name
        },
        goNextStep(){
            if (!this.queslistDocData[0].patientHeight) {
                this.$message.error('请输入患者身高');
                return
            }
            if (!this.queslistDocData[0].patientWeight) {
                this.$message.error('请填写患者体重');
                return
            }
            if (!this.queslistDocData[1].quesAnsName) {
                this.$message.error('请填写患病时间');
                return
            }
            if (!this.queslistDocData[2].quesAnsName) {
                this.$message.error('请填写本次疾病是否去过医院就诊');
                return
            }
            if (!this.queslistDocData[3].quesAnsName) {
                this.$message.error('请填写是否有正在使用的药物');
                return
            }
            if (!this.queslistDocData[4].quesAnsName) {
                this.$message.error('请填写是否有过手术、放化疗等重大疾病治疗经历');
                return
            }
            if (!this.queslistDocData[5].quesAnsName) {
                this.$message.error('请填写是否有慢性病史');
                return
            }
            if (!this.queslistDocData[6].quesAnsName) {
                this.$message.error('请填写是否有药物过敏史');
                return
            }
            if (!this.cssagree) {
                this.$message.error('请勾选相关协议');
                return
            }
            this.$confirm('一旦提交，所有信息将不可修改，确定提交吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.getAnswerList()
                }).catch(() => {

            });

        },
        getAnswerList(){
			let patientAnswerRecords = []
            for (let i = 0; i < this.queslistDocData.length; i++) {
                if (i == 0) {
                    patientAnswerRecords.push({
                        questionId: i,
                        questionText: this.queslistDocData[i].queName,
                        userAnswer: [{
                            quesAnsName: this.queslistDocData[i].quesAnsName,
                            otherData: [{
                                patientHeight: this.queslistDocData[i].patientHeight,
                                patientWeight: this.queslistDocData[i].patientWeight,
                                patienTtestTime: this.queslistDocData[i].patienTtestTime
                            }]
                        }]
                    })
                }
                if (i == 1) {
                    patientAnswerRecords.push({
                        questionId: i,
                        questionText: this.queslistDocData[i].queName,
                        userAnswer: [{
                            quesAnsName: this.queslistDocData[i].quesAnsName,
                            otherData: []
                        }]
                    })
                }
                if (i == 2) {
                    patientAnswerRecords.push({
                        questionId: i,
                        questionText: this.queslistDocData[i].queName,
                        userAnswer: [{
                            quesAnsName: this.queslistDocData[i].quesAnsName,
                            otherData: [{
                                patientHisDep: this.queslistDocData[i].patientHisDep,
                                patientHisHos: this.queslistDocData[i].patientHisHos,
                            }]
                        }]
                    })
                }
                if (i == 3) {
                    patientAnswerRecords.push({
                        questionId: i,
                        questionText: this.queslistDocData[i].queName,
                        userAnswer: [{
                            quesAnsName: this.queslistDocData[i].quesAnsName,
                            otherData: [{
                                patientHisDrug: this.queslistDocData[i].patientHisDrug,
                                patientHisDrugPhoto: this.queslistDocData[i]
                                    .patientHisDrugPhoto,
                            }]
                        }]
                    })
                }
                if (i == 4) {
                    patientAnswerRecords.push({
                        questionId: i,
                        questionText: this.queslistDocData[i].queName,
                        userAnswer: [{
                            quesAnsName: this.queslistDocData[i].quesAnsName,
                            otherData: this.queslistDocData[i].queDesOptionYes,
                        }]
                    })

                }
                if (i == 5) {
                    patientAnswerRecords.push({
                        questionId: i,
                        questionText: this.queslistDocData[i].queName,
                        userAnswer: [{
                            quesAnsName: this.queslistDocData[i].quesAnsName,
                            otherData: [{
                                diseasesDes: this.queslistDocData[i].diseasesDes
                            }],
                        }]
                    })
                }
                if (i == 6) {
                    patientAnswerRecords.push({
                        questionId: i,
                        questionText: this.queslistDocData[i].queName,
                        userAnswer: [{
                            quesAnsName: this.queslistDocData[i].quesAnsName,
                            otherData: [{
                                drugDes: this.queslistDocData[i].drugDes
                            }],
                        }]
                    })
                }

            }
            this.mesStep1.patientAnswerRecords = patientAnswerRecords
            this.mesStep1.patientAnswerRecords.map((res) => {
                res.userAnswer = JSON.stringify(res.userAnswer)
            })
            var _this = this
            _this.consultationDrugDomain.GetConsultationOrderCreateOrder(_this.mesStep1, function (data) {
                let params = {
                    info: data.data,
                    number: 3
                }
                _this.$emit('orderInfo', params); //触发事件并传递参
            },
            function (error) {
                console.log('', error)
            })
        },
        goCanBtn(){
            this.$confirm('确认取消本次问诊吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.$router.back();
                }).catch(() => {

            });
        },
        handleImagePreview(file) {
            this.Image.dialogImageUrl = file.url;
            this.Image.dialogVisible = true;
        },
        handleImageRemove(file, fileList) {
            var _this = this;
            const filePath = file.response[0].completeFilePath;
            //2.从pics数组中找到图片对应的索引值
            //形参‘x’，是数组pic里的每一项
            const i = _this.ImageContent.findIndex((x) => x.completeFilePath == filePath);
            //调用数组的splice方法，把图片的信息对象从pics数组中移除
            _this.ImageContent.splice(i, 1);
              console.log(_this.ImageContent)
        },
        handleImageUpload(response, file, fileList) {
            var _this = this;
            response.forEach(function (file) {
                var imgarr = {
                filePath: file.completeFilePath,
                fileName: file.fileName,
                type: 0
                };
                _this.ImageContent.push(imgarr);
            });
            console.log(_this.ImageContent)
        },
        goHisList(){
            this.hisdrawer = true
        },
        gochooseUser(item,index){
            this.currDocindex = index
            this.patientId = item.id
            this.patientPhone = item.phone
        }
    },
}
</script>

<style scoped>
.contentRes {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    min-height: 800px;
    margin-bottom: 20px;
}
.contentList {
    margin-top: 20px;
    width: 800px;
}
.DocTopFlexC {
    display: flex;
    align-items: center;
}
.DocTopFlexS {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.contentStep1Box {
    margin-top: 15px;
    padding: 30px;
    padding-bottom: 60px;
    background-color: #FFFFFF;
}
.step1Title {
    font-weight: bold;
    font-size: 16px;
    color: #333333;
}
.step2Title {
    font-size: 16px;
    color: #333333;
}
.BoxCheckG {
    width: 120px;
    padding: 10px 0;
    background: #F2FEFE;
    border-radius: 4px;
    border: 1px solid #B9DCDD;
    font-size: 14px;
    color: #00AFB5;
    text-align: center;
    cursor: pointer;
    margin-right: 10px;
}
.BoxG {
    width: 120px;
    padding: 10px 0;
    background: #F5F5F5;
    border-radius: 4px;
    text-align: center;
    font-size: 14px;
    color: #333333;
    cursor: pointer;
    margin-right: 10px;
} 
 .diseaseBox ::v-deep input{
    background: #F5F5F5 !important;
    /* border-radius: 4px; */
    border: none;
}
 .diseaseBox ::v-deep div{
    background: #F5F5F5 !important;
    /* border-radius: 4px; */
    border: none !important;
}

.canBtnBox {
    width: 80px;
    background: #EDEDED;
    border-radius: 4px;
    font-size: 16px;
    color: #333333;
    text-align: center;
    padding: 5px 0;
    cursor: pointer;
}
.stepBtnBox {
    width: 180px;
    background: #00AFB5;
    border-radius: 4px;
    font-size: 16px;
    color: #FFFFFF;
    text-align: center;
     padding: 5px 0;
    margin-left: 10px;
    cursor: pointer;
}
 .diseaseBox ::v-deep textarea{
    background: #F5F5F5 !important;
    border-radius: 4px;
    border: none;
}
</style>
